
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dtm/[test]",
      function () {
        return require("private-next-pages/dtm/[test].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dtm/[test]"])
      });
    }
  